<template>
    <div class="roundbox">
        <div class="rbcontent head">
            <div class="float-right">
                <form v-if="showSearch" @submit.prevent="search()" class="float-left" style="margin-right:10px;">
                    <div>
                        <div class="input-group">
                            <input type="search" class="form-control" :placeholder="translate('search')" @input="checkInput('searchText', $event)" v-model="searchText" />
                            <span class="input-group-append">
                                <button type="submit" class="btn btn-outline-secondary" style="border-color: #ced4da">
                                    <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                        <path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z"/>
                                    </svg>
                                </button>
                            </span>
                        </div>
                    </div>
                </form>
                <slot name="commands"></slot>
            </div>
            <h2>{{header}}</h2>
        </div>
        <div style="padding-bottom:15px;">
            <slot></slot>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        header: String,
        showSearch: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            searchText: ''
        };
    },
    methods:{
        checkInput(val, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this, val, editedText)
            } else {
                this.$set(this, val, event.target.value)
            }
        },
        search(){
            this.$emit('search', this.searchText);
        }
    }
}
</script>